import { type ColumnDef } from '@tanstack/react-table';

import { formatarNumero } from '@/lib/formato';
import { DocumentoTexto } from '@/ui/components/documento-texto';
import { type MetaColuna } from '@/ui/components/tabela-dados';
import { Badge } from '@/ui/primitives/badge';
import { type EmpresaResumo } from '@fiscoai/contracts';

import { PendenciasEmpresa } from './pendencias-empresa';
import { REGIME } from './rotulos';

const meta = (m: MetaColuna) => m;

export const colunasEmpresas: ColumnDef<EmpresaResumo>[] = [
  {
    id: 'empresa',
    header: 'Empresa',
    cell: ({ row }) => (
      <span className="grid min-w-0 leading-tight">
        <span className="truncate font-medium">
          {row.original.nomeFantasia ?? row.original.razaoSocial}
        </span>
        {row.original.nomeFantasia && (
          <span className="truncate text-xs text-texto-fraco">{row.original.razaoSocial}</span>
        )}
      </span>
    ),
  },
  {
    id: 'cnpj',
    header: 'CNPJ',
    meta: meta({ largura: '13rem' }),
    cell: ({ row }) => (
      <span className="flex items-center gap-1.5">
        <DocumentoTexto valor={row.original.cnpj} />
        {row.original.matriz && <Badge tom="marca">Matriz</Badge>}
      </span>
    ),
  },
  {
    id: 'regime',
    header: 'Regime',
    meta: meta({ largura: '10rem' }),
    cell: ({ row }) =>
      row.original.regimeVigente ? (
        <span>{REGIME[row.original.regimeVigente]}</span>
      ) : (
        <span className="text-alerta">Não informado</span>
      ),
  },
  {
    id: 'local',
    header: 'Local',
    meta: meta({ largura: '10rem' }),
    cell: ({ row }) => (
      <span className="text-texto-suave">
        {[row.original.municipio, row.original.uf].filter(Boolean).join('/') || '—'}
      </span>
    ),
  },
  {
    id: 'pendencias',
    header: 'Cadastro fiscal',
    meta: meta({ largura: '14rem' }),
    cell: ({ row }) => <PendenciasEmpresa empresa={row.original} />,
  },
  {
    id: 'documentos',
    header: 'Documentos',
    meta: meta({ alinhar: 'direita', largura: '7rem' }),
    cell: ({ row }) => (
      <span className="tabular">{formatarNumero(row.original.quantidadeDocumentos)}</span>
    ),
  },
];
